"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var API = /** @class */ (function () {
    function API() {
        this.listeners = {};
    }
    API.prototype.socketEvent = function (raw) {
        try {
            var message = JSON.parse(raw);
        }
        catch (e) {
            return;
        }
        if (message instanceof Object &&
            message.widgetbot === true &&
            message.id === this.id) {
            var event_1 = message.event, data_1 = message.data;
            var listeners = this.listeners[event_1];
            if (listeners) {
                listeners.forEach(function (listener) { return listener(data_1); });
            }
        }
    };
    /**
     * Listens to events from the client
     * @param event Event name
     * @param data Event data
     */
    API.prototype.on = function (event, callback) {
        if (!this.listeners[event])
            this.listeners[event] = [];
        var listeners = this.listeners[event];
        listeners.push(callback);
        console.debug("[embed-api] on '" + event + "'", callback);
    };
    return API;
}());
exports.default = API;
